import { createRow, createRow1 } from "../services/epox/views";
import { Box, BoxProps } from "./box";

export const Row = createRow<BoxProps>(Box);

export const Row1 = createRow1<BoxProps>(Box);
